﻿import { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_HIDE_DELAY = 2000;

export function useHoverVisible(hideDelay = DEFAULT_HIDE_DELAY) {
    const [visible, setVisible] = useState(true);
    const timerRef = useRef<number | null>(null);

    const clearTimer = useCallback(() => {
        if (timerRef.current !== null) {
            self.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);

    const scheduleHide = useCallback(() => {
        clearTimer();
        timerRef.current = self.setTimeout(() => setVisible(false), hideDelay);
    }, [hideDelay, clearTimer]);

    const onMouseEnter = useCallback(() => {
        clearTimer();
        setVisible(true);
    }, [clearTimer]);

    const onMouseLeave = useCallback(() => {
        scheduleHide();
    }, [scheduleHide]);

    // Auto-hide on mount after the initial delay
    useEffect(() => {
        scheduleHide();
        return clearTimer;
    }, []);

    return { visible, onMouseEnter, onMouseLeave };
}
